import {takeLatest, takeEvery} from "redux-saga";
import {fork, put, call, take} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import * as ShippingApiActions from "../actions/ShippingApiActions";
import {
  showModalWindow,
  removeModalWindow
  } from "../actions/WindowActions";
import {
  performApiLoadCall,
  performApiCallWithoutReponse
  } from "./helpers";
import * as ShippingApi from "../lib/api/ShippingApi";
import {Map} from "immutable";


// Load Availability.
function* doLoadAvailability(baseAction) {
  yield call(performApiLoadCall, ShippingApi.getAvailability, undefined, ShippingApiActions.LOAD_AVAILABILITY);
}
function* watchLoadAvailability() {
  yield takeLatest(ShippingApiActions.LOAD_AVAILABILITY.LOAD, doLoadAvailability);
}


// Load Couriers.
function* doLoadCouriers(baseAction) {
  yield call(performApiLoadCall, ShippingApi.getCouriers, undefined, ShippingApiActions.LOAD_COURIERS);
}
function* watchLoadCouriers() {
  yield takeLatest(ShippingApiActions.LOAD_COURIERS.LOAD, doLoadCouriers);
}


// Assign courier to warehouse.
function* doAssignWarehouseCourier(baseAction) {
  yield call(performApiCallWithoutReponse, ShippingApi.assignWarehouseCourier, baseAction.data, ShippingApiActions.ASSIGN_WAREHOUSE_COURIER, baseAction.formName);
}
function* watchAssignWarehouseCourier() {
  yield takeLatest(ShippingApiActions.ASSIGN_WAREHOUSE_COURIER.SUBMIT, doAssignWarehouseCourier);
}


// Handle GUI for assigning warehouses.
function* requestAssignWarehouseCourier(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AssignWarehouseCourierWindow", {id: baseAction.id}, "Assign courier"));
  yield take([ShippingApiActions.ASSIGN_WAREHOUSE_COURIER.CANCEL, ShippingApiActions.ASSIGN_WAREHOUSE_COURIER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAssignWarehouseCourier() {
  yield takeLatest(ShippingApiActions.REQUEST_ASSIGN_WAREHOUSE_COURIER, requestAssignWarehouseCourier);
}

// Handle GUI for changing delivery address.
function* requestChangeDeliveryAddress(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeShippingOrderDeliveryAddressWindow", {orderId: baseAction.orderId}, "Set shipping destination"));
  yield take([ShippingApiActions.CHANGE_DELIVERY_ADDRESS.CANCEL, ShippingApiActions.CHANGE_DELIVERY_ADDRESS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeDeliveryAddress() {
  yield takeLatest(ShippingApiActions.REQUEST_CHANGE_DELIVERY_ADDRESS, requestChangeDeliveryAddress);
}

// Handle GUI for setting delivery instructions.
function* requestSetDeliveryInstructions(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "SetCourierDeliveryInstructionsWindow", {orderId: baseAction.orderId}, "Delivery instructions for courier"));
  yield take([ShippingApiActions.SET_DELIVERY_INSTRUCTIONS.CANCEL, ShippingApiActions.SET_DELIVERY_INSTRUCTIONS.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestSetDeliveryInstructions() {
  yield takeLatest(ShippingApiActions.REQUEST_SET_DELIVERY_INSTRUCTIONS, requestSetDeliveryInstructions);
}

// Handle GUI for assigning warehouse to an order.
function* requestAssignWarehouseToOrder(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AssignWarehouseToOrderWindow", {orderId: baseAction.orderId}, "Assign warehouse"));
  yield take([ShippingApiActions.ASSIGN_WAREHOUSE_TO_ORDER.CANCEL, ShippingApiActions.ASSIGN_WAREHOUSE_TO_ORDER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAssignWarehouseToOrder() {
  yield takeLatest(ShippingApiActions.REQUEST_ASSIGN_WAREHOUSE_TO_ORDER, requestAssignWarehouseToOrder);
}


// Handle GUI for changing warehouse for an order.
function* requestChangeWarehouseForOrder(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangeWarehouseForOrderWindow", {orderId: baseAction.orderId}, "Change warehouse"));
  yield take([ShippingApiActions.CHANGE_WAREHOUSE_FOR_ORDER.CANCEL, ShippingApiActions.CHANGE_WAREHOUSE_FOR_ORDER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangeWarehouseForOrder() {
  yield takeLatest(ShippingApiActions.REQUEST_CHANGE_WAREHOUSE_FOR_ORDER, requestChangeWarehouseForOrder);
}


// Handle GUI for scheduling shipment.
function* requestScheduleShipment(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ScheduleShipmentWindow", {orderId: baseAction.orderId}, "Schedule Shipment"));
  yield take([ShippingApiActions.SCHEDULE_SHIPMENT.CANCEL, ShippingApiActions.SCHEDULE_SHIPMENT.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestScheduleShipment() {
  yield takeLatest(ShippingApiActions.REQUEST_SCHEDULE_SHIPMENT, requestScheduleShipment);
}

// Handle GUI for unscheduling shipment.
function* requestUnscheduleShipment(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "UnscheduleShipmentWindow", {orderId: baseAction.orderId}, "Unschedule Shipment"));
  yield take([ShippingApiActions.UNSCHEDULE_SHIPMENT.CANCEL, ShippingApiActions.UNSCHEDULE_SHIPMENT.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestUnscheduleShipment() {
  yield takeLatest(ShippingApiActions.REQUEST_UNSCHEDULE_SHIPMENT, requestUnscheduleShipment);
}

// Handle GUI for cancelling shipping order.
function* requestCancelShippingOrder(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CancelShippingOrderWindow", {orderId: baseAction.orderId}, "Cancel shipping order"));
  yield take([ShippingApiActions.CANCEL_SHIPPING_ORDER.CANCEL, ShippingApiActions.CANCEL_SHIPPING_ORDER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestCancelShippingOrder() {
  yield takeLatest(ShippingApiActions.REQUEST_CANCEL_SHIPPING_ORDER, requestCancelShippingOrder);
}

// Handle GUI for viewing edi message data.
function* requestViewEdiMessageData(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ViewEdiMessageDataWindow", {id: baseAction.id}, `Edi Message #${baseAction.id}`));
  yield take([ShippingApiActions.VIEW_EDI_MESSAGE_DATA.CANCEL, ShippingApiActions.VIEW_EDI_MESSAGE_DATA.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestViewEdiMessageData() {
  yield takeLatest(ShippingApiActions.REQUEST_VIEW_EDI_MESSAGE_DATA, requestViewEdiMessageData);
}



// Handle GUI for adding products to shipping order.
function* requestAddProductToShippingOrder(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AddProductToShippingOrderWindow", {orderId: baseAction.orderId, shopId: baseAction.shopId}, "Add product to shipment"));
  yield take([ShippingApiActions.ADD_PRODUCT_TO_SHIPPING_ORDER.CANCEL, ShippingApiActions.ADD_PRODUCT_TO_SHIPPING_ORDER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAddProductToShippingOrder() {
  yield takeLatest(ShippingApiActions.REQUEST_ADD_PRODUCT_TO_SHIPPING_ORDER, requestAddProductToShippingOrder);
}

// Handle GUI for removing a package from a shipping order.
function* requestRemovePackageFromShippingOrder(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RemovePackageFromShippingOrderWindow", {orderId: baseAction.orderId, packageId: baseAction.packageId}, "Remove package from order"));
  yield take([ShippingApiActions.REMOVE_PACKAGE_FROM_SHIPPING_ORDER.CANCEL, ShippingApiActions.REMOVE_PACKAGE_FROM_SHIPPING_ORDER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRemovePackageFromShippingOrder() {
  yield takeLatest(ShippingApiActions.REQUEST_REMOVE_PACKAGE_FROM_SHIPPING_ORDER, requestRemovePackageFromShippingOrder);
}

// Handle GUI for creating a replacement order for selected packages.
function* requestReplacePackagesForShippingOrder(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ReplacePackagesForShippingOrderWindow", {orderId: baseAction.orderId, packageIds: baseAction.packageIds}, "Replacement Order for Packages"));
  yield take([ShippingApiActions.REPLACE_PACKAGES_FOR_SHIPPING_ORDER.CANCEL, ShippingApiActions.REPLACE_PACKAGES_FOR_SHIPPING_ORDER.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestReplacePackagesForShippingOrder() {
  yield takeLatest(ShippingApiActions.REQUEST_REPLACE_PACKAGES_FOR_SHIPPING_ORDER, requestReplacePackagesForShippingOrder);
}

// Handle GUI for changing package status.
function* requestChangePackageDeliveryStatusDelivered(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangePackageDeliveryStatusDeliveredWindow", {orderId: baseAction.orderId, trackingNr: baseAction.trackingNr}, `Mark Package "${baseAction.trackingNr}" as Delivered`));
  yield take([ShippingApiActions.CHANGE_PACKAGE_DELIVERY_STATUS_DELIVERED.CANCEL, ShippingApiActions.CHANGE_PACKAGE_DELIVERY_STATUS_DELIVERED.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangePackageDeliveryStatusDelivered() {
  yield takeLatest(ShippingApiActions.REQUEST_CHANGE_PACKAGE_DELIVERY_STATUS_DELIVERED, requestChangePackageDeliveryStatusDelivered);
}

// Handle GUI for changing package status.
function* requestChangePackageDeliveryStatusPickedUp(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ChangePackageDeliveryStatusPickedUpWindow", {orderId: baseAction.orderId, trackingNr: baseAction.trackingNr}, `Mark Package "${baseAction.trackingNr}" as Picked Up`));
  yield take([ShippingApiActions.CHANGE_PACKAGE_DELIVERY_STATUS_PICKED_UP.CANCEL, ShippingApiActions.CHANGE_PACKAGE_DELIVERY_STATUS_PICKED_UP.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestChangePackageDeliveryStatusPickedUp() {
  yield takeLatest(ShippingApiActions.REQUEST_CHANGE_PACKAGE_DELIVERY_STATUS_PICKED_UP, requestChangePackageDeliveryStatusPickedUp);
}

// Handle GUI for requesting a stock reservation.
function* requestRequestStockReservation(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RequestStockReservationWindow", {orderId: baseAction.orderId}, "Request Stock Reservation"));
  yield take([ShippingApiActions.REQUEST_STOCK_RESERVATION.CANCEL, ShippingApiActions.REQUEST_STOCK_RESERVATION.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRequestStockReservation() {
  yield takeLatest(ShippingApiActions.REQUEST_REQUEST_STOCK_RESERVATION, requestRequestStockReservation);
}

// Handle GUI for requesting a shipping quote.
function* requestRequestShippingQuote(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "RequestShippingQuoteWindow", {orderId: baseAction.orderId}, "Request Quote"));
  yield take([ShippingApiActions.REQUEST_SHIPPING_QUOTE.CANCEL, ShippingApiActions.REQUEST_SHIPPING_QUOTE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestRequestShippingQuote() {
  yield takeLatest(ShippingApiActions.REQUEST_REQUEST_SHIPPING_QUOTE, requestRequestShippingQuote);
}

// Handle GUI for accepting a shipping quote.
function* requestAcceptShippingQuote(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AcceptShippingQuoteWindow", {orderId: baseAction.orderId}, "Accept Quote"));
  yield take([ShippingApiActions.ACCEPT_SHIPPING_QUOTE.CANCEL, ShippingApiActions.ACCEPT_SHIPPING_QUOTE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestAcceptShippingQuote() {
  yield takeLatest(ShippingApiActions.REQUEST_ACCEPT_SHIPPING_QUOTE, requestAcceptShippingQuote);
}

// Handle GUI for voiding a shipping quote.
function* requestVoidShippingQuote(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "VoidShippingQuoteWindow", {orderId: baseAction.orderId}, "Void Quote"));
  yield take([ShippingApiActions.VOID_SHIPPING_QUOTE.CANCEL, ShippingApiActions.VOID_SHIPPING_QUOTE.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestVoidShippingQuote() {
  yield takeLatest(ShippingApiActions.REQUEST_VOID_SHIPPING_QUOTE, requestVoidShippingQuote);
}

// Handle GUI for marking shipment as complimentary.
function* requestMarkShipmentAsComplimentary(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "MarkShipmentAsComplimentaryWindow", {orderId: baseAction.orderId}, "Complimentary Shipment"));
  yield take([ShippingApiActions.MARK_SHIPMENT_AS_COMPLIMENTARY.CANCEL, ShippingApiActions.MARK_SHIPMENT_AS_COMPLIMENTARY.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestMarkShipmentAsComplimentary() {
  yield takeLatest(ShippingApiActions.REQUEST_MARK_SHIPMENT_AS_COMPLIMENTARY, requestMarkShipmentAsComplimentary);
}

// Handle GUI for holding shipment.
function* requestHoldShipment(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "HoldShipmentWindow", {orderId: baseAction.orderId}, "Hold Shipment"));
  yield take([ShippingApiActions.HOLD_SHIPMENT.CANCEL, ShippingApiActions.HOLD_SHIPMENT.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestHoldShipment() {
  yield takeLatest(ShippingApiActions.REQUEST_HOLD_SHIPMENT, requestHoldShipment);
}

// Handle GUI for releasing hold of shipment.
function* requestReleaseShipmentHold(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "ReleaseShipmentHoldWindow", {orderId: baseAction.orderId}, "Release Shipment Hold"));
  yield take([ShippingApiActions.RELEASE_SHIPMENT_HOLD.CANCEL, ShippingApiActions.RELEASE_SHIPMENT_HOLD.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestReleaseShipmentHold() {
  yield takeLatest(ShippingApiActions.REQUEST_RELEASE_SHIPMENT_HOLD, requestReleaseShipmentHold);
}

// Handle GUI for starting shipment.
function* requestProcessShipment(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "StartShipmentWindow", {orderId: baseAction.orderId}, "Start Shipment"));
  yield take([ShippingApiActions.PROCESS_SHIPMENT.CANCEL, ShippingApiActions.PROCESS_SHIPMENT.SUCCESS]);
  yield put(removeModalWindow(windowId));
}
function* watchRequestProcessShipment() {
  yield takeLatest(ShippingApiActions.REQUEST_PROCESS_SHIPMENT, requestProcessShipment);
}


// Handle GUI for setting availability.
function* doWatchRequestCreateOrder(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "CreateShippingOrderWindow", {}, "Specify destination for new shipment"));
  yield take([ShippingApiActions.CREATE_SHIPPING_ORDER.CANCEL, ShippingApiActions.CREATE_SHIPPING_ORDER.SUCCESS]);
  yield put(removeModalWindow(windowId));  
}
function* watchRequestCreateOrder() {
  yield takeLatest(ShippingApiActions.REQUEST_CREATE_SHIPPING_ORDER, doWatchRequestCreateOrder)
}



// Handle GUI for setting availability.
function* doWatchRequestSetAvailability(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "SetAvailabilityWindow", {data: baseAction.data}, `Set Availability for ${baseAction.data.get("name")}`));
  yield take([ShippingApiActions.SET_AVAILABILITY.CANCEL, ShippingApiActions.SET_AVAILABILITY.SUCCESS]);
  yield put(removeModalWindow(windowId));  
}
function* watchRequestSetAvailability() {
  yield takeLatest(ShippingApiActions.REQUEST_SET_AVAILABILITY, doWatchRequestSetAvailability)
}


// Handle GUI for assigning warehouse to location.
function* doRequestAssignWarehouseToLocation(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "AssignWarehouseToLocationWindow", {kind: baseAction.kind, code: baseAction.code, warehouseId: baseAction.warehouseId}, `Assign Warehouse to ${baseAction.name}`));
  yield take([ShippingApiActions.ASSIGN_WAREHOUSE_TO_LOCATION.CANCEL, ShippingApiActions.ASSIGN_WAREHOUSE_TO_LOCATION.SUCCESS]);
  yield put(removeModalWindow(windowId));  
}
function* watchRequestAssignWarehouseToLocation() {
  yield takeLatest(ShippingApiActions.REQUEST_ASSIGN_WAREHOUSE_TO_LOCATION, doRequestAssignWarehouseToLocation);
}


function* assignWarehouseToLocation(baseAction) {
  yield call(performApiCallWithoutReponse, ShippingApi.assignWarehouseToLocation, baseAction.data, ShippingApiActions.ASSIGN_WAREHOUSE_TO_LOCATION);  
}
function* watchAssignWarehouseToLocation() {
  yield takeEvery(ShippingApiActions.ASSIGN_WAREHOUSE_TO_LOCATION.SUBMIT, assignWarehouseToLocation);
}


// Set availability.
function* doWatchSetAvailability(baseAction) {
  yield call(performApiCallWithoutReponse, ShippingApi.setAvailability, baseAction.data, ShippingApiActions.SET_AVAILABILITY);
}
function* watchSetAvailability() {
  yield takeEvery(ShippingApiActions.SET_AVAILABILITY.SUBMIT, doWatchSetAvailability);
}


// Load availability for country.
function* doLoadAvailabilityForCountry(baseAction) {
  yield call(performApiLoadCall, ShippingApi.getAvailabilityForCountry, Map({country: baseAction.country}), ShippingApiActions.LOAD_AVAILABILITY_FOR_COUNTRY);
}
function* watchLoadAvailabilityForCountry() {
  yield takeEvery(ShippingApiActions.LOAD_AVAILABILITY_FOR_COUNTRY.LOAD, doLoadAvailabilityForCountry);
}


// Load availability for US State.
function* doLoadAvailabilityForUSState(baseAction) {
  yield call(performApiLoadCall, ShippingApi.getAvailabilityForUSState, Map({state: baseAction.state}), ShippingApiActions.LOAD_AVAILABILITY_FOR_US_STATE);
}
function* watchLoadAvailabilityForUSState() {
  yield takeEvery(ShippingApiActions.LOAD_AVAILABILITY_FOR_US_STATE.LOAD, doLoadAvailabilityForUSState);
}


export default function* saga() {
  yield fork(watchLoadAvailability);
  yield fork(watchLoadCouriers);
  yield fork(watchRequestAssignWarehouseCourier);
  yield fork(watchAssignWarehouseCourier);
  yield fork(watchRequestSetAvailability);
  yield fork(watchRequestAssignWarehouseToLocation);
  yield fork(watchAssignWarehouseToLocation);
  yield fork(watchSetAvailability);
  yield fork(watchLoadAvailabilityForCountry);
  yield fork(watchLoadAvailabilityForUSState);
  yield fork(watchRequestCreateOrder);
  yield fork(watchRequestChangeDeliveryAddress);
  yield fork(watchRequestSetDeliveryInstructions);
  yield fork(watchRequestAssignWarehouseToOrder);
  yield fork(watchRequestChangeWarehouseForOrder);
  yield fork(watchRequestAddProductToShippingOrder);
  yield fork(watchRequestRemovePackageFromShippingOrder);
  yield fork(watchRequestReplacePackagesForShippingOrder);
  yield fork(watchRequestChangePackageDeliveryStatusPickedUp);
  yield fork(watchRequestChangePackageDeliveryStatusDelivered);
  yield fork(watchRequestRequestStockReservation);
  yield fork(watchRequestRequestShippingQuote);
  yield fork(watchRequestAcceptShippingQuote);
  yield fork(watchRequestVoidShippingQuote);
  yield fork(watchRequestHoldShipment);
  yield fork(watchRequestReleaseShipmentHold);
  yield fork(watchRequestProcessShipment);
  yield fork(watchRequestCancelShippingOrder);
  yield fork(watchRequestViewEdiMessageData);
  yield fork(watchRequestScheduleShipment);
  yield fork(watchRequestUnscheduleShipment);
  yield fork(watchRequestMarkShipmentAsComplimentary);
}
